var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36482 4.42982L8.90567 5.39892C9.39375 6.27349 9.19782 7.42078 8.42909 8.1895C8.42909 8.18951 8.42909 8.18951 8.42909 8.18951C8.42897 8.18962 7.49675 9.12207 9.18726 10.8126C10.8771 12.5024 11.8095 11.5716 11.8103 11.5708C11.8104 11.5707 11.8103 11.5707 11.8104 11.5707C12.5791 10.802 13.7264 10.6061 14.6009 11.0942L15.57 11.635C16.8906 12.372 17.0466 14.224 15.8858 15.3848C15.1883 16.0823 14.3338 16.6251 13.3893 16.6609C11.7991 16.7212 9.09873 16.3187 6.38992 13.6099C3.6811 10.9011 3.27867 8.20069 3.33896 6.61058C3.37476 5.66601 3.9175 4.81154 4.615 4.11403C5.77579 2.95324 7.62781 3.10921 8.36482 4.42982Z",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.208659c5d6d39836ccbfecda24f86cb0.svg";
export { ForwardRef as ReactComponent };